import { requireStringEnvVar } from "../../config";

export const buildDoffinNoticeUrl = (externalId: string): string =>
  `${requireStringEnvVar("VITE_DOFFIN_NOTICE_BASE_URL")}/${externalId}`;
